//import '../css/common.scss';
import * as commonScript from './_common.js';


if (document.readyState !== "loading") {
	commonScript.init();
}else {
	document.addEventListener('DOMContentLoaded', function(){
		commonScript.init();
	});
}

const removeOverWrap=setTimeout(() => {
	try{
		document.getElementById("overWrap").remove();
	}catch(e){
		console.log("overWrap after remove")
	}
}, 1000);

if (document.readyState == "complete") {
	try{
		clearTimeout(removeOverWrap);
		document.getElementById("overWrap").remove();
	}catch(e){
		console.log("overWrap nothing")
	}
}else{
	window.onload=function() {
		try{
			clearTimeout(removeOverWrap);
			document.getElementById("overWrap").remove();
		}catch(e){
			console.log("overWrap removed")
		}
	}
}
